const USER_TOKEN_KEY = 'auth_token'

const originalFetch = window.fetch.bind(window)

window.fetch = (input: RequestInfo | URL, init?: RequestInit) => {
  const token = localStorage.getItem(USER_TOKEN_KEY)
  console.log('Current user token:', token)

  const request = new Request(input, init)

  if (
    token &&
    !request.headers.has('Authorization')
  ) {
    request.headers.set('Authorization', `Bearer ${token}`)
  }

  return originalFetch(request)
}